module.exports = __webpack_public_path__ + "img/sun.44e505c4.svg";